var _path, _path2, _path3, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8GhanaCircular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fbc02d",
    d: "M5.675,16C4.604,18.451,4,21.154,4,24s0.604,5.549,1.675,8h36.649C43.396,29.549,44,26.846,44,24 s-0.604-5.549-1.675-8H5.675z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M24,4C15.801,4,8.763,8.939,5.675,16h36.649C39.237,8.939,32.199,4,24,4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#388e3c",
    d: "M24,44c8.199,0,15.237-4.939,18.325-12H5.675C8.763,39.061,15.801,44,24,44z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#212121",
    points: "27.2,25.92 32.32,22.08 25.92,22.08 24,16 22.08,22.08 15.68,22.08 20.8,25.92 18.88,32 24,28.32 29.12,32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8GhanaCircular);
export default __webpack_public_path__ + "static/media/icons8-ghana-circular.24fbab73528fde611fcffc067d8ab32d.svg";
export { ForwardRef as ReactComponent };